import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../context/user-context";
import { HiOutlineHome, HiArrowLeft } from "react-icons/hi";
import { MdErrorOutline } from "react-icons/md";

const NotFound: React.FC = () => {
  const { userDetails } = useUser();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-[#F7F8F9] dark:bg-[#13181B] px-4">
      <div className="max-w-md w-full text-center py-12 px-6 bg-white dark:bg-[#232B36] rounded-2xl shadow-xl animate-fadeInUp">
        <div className="flex justify-center mb-6 animate-fadeIn">
          <MdErrorOutline className="text-[60px] text-red-500" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white animate-fadeIn delay-100">
          Oops! Page Not Found
        </h1>
        <p className="mt-3 text-gray-500 dark:text-gray-300 animate-fadeIn delay-200">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="mt-10 flex flex-col gap-3 animate-fadeIn delay-300">
          <button
            onClick={() => navigate(-1)}
            className="w-full py-3 rounded-xl bg-[#0B75C2] text-white font-semibold hover:bg-[#095B97] flex justify-center items-center gap-2 transition"
          >
            <HiArrowLeft className="text-lg" />
            Go Back
          </button>
          <Link
            to={userDetails?.user ? "/dashboard" : "/"}
            className="w-full block py-3 rounded-xl border border-[#0B75C2] text-[#0B75C2] font-semibold hover:bg-[#E7EBEE] dark:hover:bg-[#192025] flex justify-center items-center gap-2 transition"
          >
            <HiOutlineHome className="text-lg" />
            {userDetails?.user ? "Go to Dashboard" : "Go to Home"}
          </Link>
        </div>
      </div>

      {/* CSS animations */}
      <style>
        {`
          .animate-fadeIn {
            opacity: 0;
            animation: fadeIn 0.8s forwards;
          }
          .animate-fadeInUp {
            opacity: 0;
            transform: translateY(20px);
            animation: fadeInUp 0.8s forwards;
          }
          .animate-fadeIn.delay-100 { animation-delay: 0.1s; }
          .animate-fadeIn.delay-200 { animation-delay: 0.2s; }
          .animate-fadeIn.delay-300 { animation-delay: 0.3s; }

          @keyframes fadeIn {
            to {
              opacity: 1;
            }
          }
          @keyframes fadeInUp {
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default NotFound;
